import { useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

export const useIsLoggedIn = () => {
  const { authMachineRef } = useEssentialMachines();

  const isLoggedIn = useSelector(authMachineRef, (state) => {
    return state.matches({ session: 'loggedIn' });
  });

  return Boolean(isLoggedIn);
};
